import { Box, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FaChevronRight } from 'react-icons/fa'
import { colors } from '../../../utilities/colors'
import { priceOptionColors, priceOptionIcons } from '../shared/priceOptions'
import StatusBadge from '../shared/StatusBadge'
import { orderStatusColor } from '../shared/orderStatus'

export default function OrderRow({ order, onClick }) {
  const { t } = useTranslation()
  const details = order.attributes['response-cache']
  const createdAt = order.attributes['created-at']
  const status = order.attributes['status']
  const vehicles = details?.vehicles || []
  const orderLabel = vehicles.length === 1
    ? `${vehicles[0].year} ${vehicles[0].make} ${vehicles[0].model}`
    : `${vehicles.length} ${t('Vehicles')}`

  const formatCityStateZip = (loc) =>
    loc ? [loc.city, loc.state, loc.postal_code || loc.zip].filter(Boolean).join(', ') : ''
  const originLabel = formatCityStateZip(details?.origin)
  const destinationLabel = formatCityStateZip(details?.destination)
  const priceOption = order.attributes['price-option']
  const amount = order.attributes['amount']

  const handleClick = () => {
    if (onClick) onClick(order)
  }

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={handleClick}
      display="block"
    >
      <Box
        display="flex"
        alignItems="center"
        py={3}
        px={2}
        borderBottom="1px solid"
        borderColor={colors.grey700}
        _hover={{ bg: colors.grey700 }}
        cursor="pointer"
        transition="background 0.15s"
      >
        <Box display="flex" flexDirection="column" gap={1} flex={1} minWidth={0}>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize="sm" fontWeight="bold" color={colors.grey100} minWidth={0} flex={1} truncate>
              {`${createdAt} · ${orderLabel}`}
            </Text>
            <Box flexShrink={0}>
              <StatusBadge label={status} color={orderStatusColor(status)} />
            </Box>
          </Box>
          {(originLabel || destinationLabel) && (
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
              <Text fontSize="xs" color={colors.grey300} flex={1} minWidth={0} truncate>
                {t('From')}: <Text as="span" color={colors.grey100}>{originLabel}</Text>
              </Text>
              <Text fontSize="xs" color={colors.grey300} flex={1} minWidth={0} truncate textAlign="right">
                {t('To')}: <Text as="span" color={colors.grey100}>{destinationLabel}</Text>
              </Text>
            </Box>
          )}
          {(priceOption || amount != null) && (
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={1} flex={1} minWidth={0}>
                {priceOptionIcons[priceOption] && (
                  <Box
                    as={priceOptionIcons[priceOption]}
                    size="12px"
                    color={priceOptionColors[priceOption] || colors.grey300}
                    flexShrink={0}
                  />
                )}
                <Text
                  fontSize="xs"
                  fontWeight="semibold"
                  textTransform="capitalize"
                  color={priceOptionColors[priceOption] || colors.grey300}
                  minWidth={0}
                  truncate
                >
                  {priceOption}
                </Text>
              </Box>
              {amount != null && (
                <Text fontSize="xs" fontWeight="semibold" color={colors.grey100} flexShrink={0}>
                  ${Math.round(amount).toLocaleString()}
                </Text>
              )}
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize="xs" color={colors.grey300} flexShrink={0}>{t('Created by')}</Text>
            <Text fontSize="xs" color={colors.grey300} minWidth={0} truncate>
              {order.attributes['created-by']}
            </Text>
          </Box>
        </Box>
        <Box ml={3} color={colors.grey500}>
          <FaChevronRight size={12} />
        </Box>
      </Box>
    </Box>
  )
}
